export default { 
    async createBoleto ({commit, getters}, plano){
        let request = getters.getUserLocal
        request.plano = plano
        let {data} = await getters.getApi.post(`payment`, request)
        return data
    },

    async loadBoletos ({commit, getters}, plano){
        let {data} = await getters.getApi.get('paymentHistory')
        return data.data
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/creditos/actions.js